import { createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'src/utils/axios'

export const fetchUrl = createAsyncThunk(
  'FETCH_URL_FOR_RESULTS',
  async ({ url, page, offset }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(url, {
        params: { page: page + 1, offset },
      })
      return response.data
    } catch (err) {
      console.error('Error in fetchUrl: ', err)

      return rejectWithValue(err)
    }
  }
)
